import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button } from "rhombus-react";

import { getAutoClassificationEnabled, getRemainingCredits } from "selectors/Intelligence";
import { sendForAutoClassification } from "reducers/CreativeVersions";
import { NON_AUTOCLASSIFIABLE_ADTYPES, VERSION_STATUS } from "utils/constants";
import { isApproved } from "utils/CreativeActions";

export default function AutoClassifyButton(props){
	const { creativeId } = props;
	const dispatch = useDispatch();

	const isSaving = useSelector(state => state.creativeVersions?.classification?.isSaving);
	const isAutoClassificationEnabled = useSelector(getAutoClassificationEnabled);
	const remainingCredits = useSelector(getRemainingCredits);
	const selectedVersions = useSelector(state => state.selected?.versions || []);
	const versions = useSelector(state => state.creativeVersions?.items || []);
	const { adType, approval } = useSelector(state => state.creativeDetails);

	const isClassifiableAdType = !NON_AUTOCLASSIFIABLE_ADTYPES.includes(adType);

	const classifiableVersions = useMemo(() => {
		const selectedVersionsSet = new Set(selectedVersions);

		return versions.reduce((prev, version) => {
			if((version.status !== VERSION_STATUS.UNPUBLISHED) && selectedVersionsSet.has(version.id)){
				prev.push(version.id);
			}
			return prev;
		}, []);
	}, [versions, selectedVersions]);
	const numVersions = classifiableVersions.length;

	if(!isAutoClassificationEnabled || !numVersions || !isClassifiableAdType || !isApproved(approval)){
		return null;
	}

	function onClick(){
		dispatch(sendForAutoClassification(creativeId, classifiableVersions));
	}

	return (
		<Button
			icon="fas fa-tags"
			style="block"
			disabled = {(remainingCredits < numVersions) || isSaving}
			onClick = {onClick}
		>
			Send for Auto-Classification ({numVersions})
		</Button>
	);
}

AutoClassifyButton.displayName = "AutoClassifyButton";
